
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.993 15.991c0-.529.461-.991.992-.991.547 0 1.008.462 1.008.991A1.01 1.01 0 0111.985 17c-.531 0-.992-.445-.992-1.009zm.451-3.498c0-2.532 2.471-1.495 2.471-3.691 0-1.024-.806-1.751-1.925-1.751-1.092 0-1.884.768-1.898 1.805H9C9 7.225 10.269 6 11.99 6c1.733 0 3.003 1.199 3.003 2.802 0 2.641-2.444 2.048-2.444 3.57v.957h-1.105v-.836z"}})])
          )
        }
      }
    